import { Helmet } from "react-helmet";
import React, { Component } from "react";
import { Button, Form, Table } from "react-bootstrap";
import "../../styles/devices/devices.scss";
import axios from "axios";
import { apiHost } from "../../api/apiClient";
import Search from "../commoncomponents/Search";
import ShowEntries from "../commoncomponents/ShowEntries";
import { encodeQueryData } from "../../api/apiClient";
import Paginations from "../commoncomponents/pagination";
import ShowingResults from "../commoncomponents/showingResults";
import Layout from "../../Layout/layout";
import { setLoadingPage, setErrorMessage } from "../../reducers/actions";
import { connect } from "react-redux";
import { utcToLocal } from "../../utils/dateConvert";

const WEB_DMC_DEVICE_BASE_URL =
  "https://vttoolsv2-assettrak.visiontrak.com.au/Reports/DMC/dmc_web_device.php?device=";

class EditDevice extends Component {
  constructor(props) {
    super(props);
    this.state = {
      deviceDetails: [],
      customerList: [],
      statusList: [],
      assetsList: [],
      roles: [],
      customerID: "default",
      imei: "",
      name: "",
      description: "",
      sim: "",
      type: "1",
      tag: "",
      networkType: "",
      firmware: "",
      assetId: "",
      assetName: "",
      status: "1",
      statusName: "",
      dmcStatusLoading: false,
      dmcStatus: null,
      customerID_error: false,
      name_error: false,
      imei_error: false,
      assetsPageCount: 0,
      //states for showing entries and total entries in page on Assets
      totalEntryA: 0,
      entryStartA: "0",
      entryEndA: "0",
      totalFilterA: false,
      totalEntryFilterA: "0",
      filterMessageA: false,
    };
    this.customerid = "";
    this.deviceId = "";
    this.assetSearchText = "";
    this.assetPageKey = "1";
    this.assetPageSize = "10";
    this.imei = "";
    this.dmcStatusPollTimer = null;

    this.formSubmit = false;
  }
  async componentDidMount() {
    this.deviceId = this.props.match.params.id;
    console.log(this.deviceId);
    let urlDevices = `${apiHost}/api/Device/SelectDevice/${this.deviceId}`;
    this.getDevices(urlDevices);
    let urlCustomer = `${apiHost}/api/Customer/GetAllCustomers`;
    this.getCustomer(urlCustomer);
    let urlStatus = `${apiHost}/api/Device/GetAllDeviceStatus`;
    this.getStatus(urlStatus);
  }

  getDevices = async (url) => {
    //Get all Device list
    this.props.setLoadingPageAction(true);

    try {
      const deviceDetails = await axios.get(
        url,

        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );
      const device = deviceDetails.data;
      const customerID = device.customerId || "default";
      this.imei = device.imei;
      this.setState(
        {
          deviceDetails: device,
          imei: device.imei || "",
          name: device.name || "",
          description: device.description || "",
          sim: device.simNumber || "",
          type: device.type || "",
          tag: device.tag || "",
          networkType: device.networkType || "",
          firmware: device.firmware || "",
          customerID,
          assetId: device.assetId || "",
          assetName: device.assetId ? device.assetName : "",
          status: device.deviceStatus || "",
        },
        () => {
          this.loadDeviceDmcStatus();
          this.startDeviceDmcStatusPolling();
          if (this.state.customerID !== "default") {
            let query = encodeQueryData(this.setAssetQueryObject());
            let urlAssets = `${apiHost}/api/Device/AssetsByCustomerIdForDevice/${this.state.customerID}?${query}`;
            this.postAssets(urlAssets);
          }
        }
      );
      console.log("deviceDetails ", device);
      this.props.setLoadingPageAction(false);
    } catch (e) {
      if (e.response && e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`);
      }
      this.props.setLoadingPageAction(false);

      console.log(`😱 Axios request failed: ${e}`);
    }
  };

  componentWillUnmount() {
    this.stopDeviceDmcStatusPolling();
  }

  loadDeviceDmcStatus = (silent = false) => {
    const imei = this.state.imei || this.imei;
    if (!imei) {
      this.setState({ dmcStatusLoading: false, dmcStatus: null });
      return;
    }

    if (!silent) {
      this.setState({ dmcStatusLoading: true });
    }

    axios
      .get(`${apiHost}/api/Device/DmcStatus/${encodeURIComponent(imei)}`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
      .then((response) => {
        this.setState({
          dmcStatusLoading: false,
          dmcStatus: response.data || null,
        });
      })
      .catch(() => {
        this.setState({
          dmcStatusLoading: false,
          dmcStatus: { isOnline: false },
        });
      });
  };

  startDeviceDmcStatusPolling = () => {
    this.stopDeviceDmcStatusPolling();
    this.dmcStatusPollTimer = setInterval(() => {
      if (document.hidden) return;
      this.loadDeviceDmcStatus(true);
    }, 3000);
  };

  stopDeviceDmcStatusPolling = () => {
    if (this.dmcStatusPollTimer) {
      clearInterval(this.dmcStatusPollTimer);
      this.dmcStatusPollTimer = null;
    }
  };

  handleOpenWebDmc = () => {
    const imei = this.state.imei || this.imei;
    if (!imei || !(this.state.dmcStatus && this.state.dmcStatus.isOnline === true)) {
      return;
    }

    window.open(
      `${WEB_DMC_DEVICE_BASE_URL}${encodeURIComponent(imei)}`,
      "_blank",
      "noopener,noreferrer"
    );
  };

  getCustomer = async (url) => {
    //Get all customer id
    this.props.setLoadingPageAction(true);

    try {
      const customerList = await axios.get(url, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });
      this.setState({ customerList: customerList.data });
      console.log("customer id", customerList.data);
      this.props.setLoadingPageAction(false);
    } catch (e) {
      if (e.response && e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`);
      }
      this.props.setLoadingPageAction(false);

      console.log(`😱 Axios request failed: ${e}`);
    }
  };

  getStatus = async (url) => {
    //Get all Status
    this.props.setLoadingPageAction(true);

    try {
      const statusList = await axios.get(url, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });
      this.setState({ statusList: statusList.data });
      console.log("status ", statusList.data);
      this.props.setLoadingPageAction(false);
    } catch (e) {
      if (e.response && e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`);
      }
      this.props.setLoadingPageAction(false);

      console.log(`😱 Axios request failed: ${e}`);
    }
  };

  unCheckradio = () => {
    var radio = document.getElementsByClassName("inputRadio");
    for (var i in radio) {
      if (radio[i].checked) {
        radio[i].checked = false;
      }
    }
  };
  handleAssetClear = () => {
    this.unCheckradio();
    this.setState({
      assetId: "",
      assetName: "",
    });
  };
  handleAssetSearch = (inputSearch) => {
    if (inputSearch == "") {
      this.setState({ filterMessageA: false });
    } else {
      this.setState({ filterMessageA: true });
    }
    this.unCheckradio();

    this.assetSearchText = inputSearch;
    let query = encodeQueryData(this.setAssetQueryObject());
    let urlAll = `${apiHost}/api/Device/AssetsByCustomerIdForDevice/${this.state.customerID}?${query}`;
    this.postAssets(urlAll);
  };
  handleAssetShowEntries = (input) => {
    this.unCheckradio();

    this.assetPageSize = input;
    let query = encodeQueryData(this.setAssetQueryObject());
    let urlAll = `${apiHost}/api/Device/AssetsByCustomerIdForDevice/${this.state.customerID}?${query}`;
    this.postAssets(urlAll);
  };
  handleAssetPagination = (page) => {
    this.unCheckradio();
    this.assetPageKey = page;
    let query = encodeQueryData(this.setAssetQueryObject());
    let urlAll = `${apiHost}/api/Device/AssetsByCustomerIdForDevice/${this.state.customerID}?${query}`;
    this.postAssets(urlAll);
  };

  setAssetQueryObject = () => {
    let data = {};
    data.SearchString = this.assetSearchText;
    data.PageSize = this.assetPageSize;
    data.PageNumber = this.assetPageKey;
    data.DeviceId = this.deviceId;
    return data;
  };
  handleShowAssetsResults = (response) => {
    // function for showing entries and total entries in page

    this.setState({
      totalEntryA: JSON.parse(response.headers.pagination).totalItems,
    });
    if (!this.state.totalFilterA) {
      this.setState({
        totalEntryFilterA: JSON.parse(response.headers.pagination).totalItems,
        totalFilterA: true,
      });
    }
    this.setState({
      entryStartA:
        (parseInt(this.assetPageKey) - 1) * parseInt(this.assetPageSize) + 1,
    });
    if (
      JSON.parse(response.headers.pagination).totalItems <
      parseInt(this.state.entryEndA)
    ) {
      this.setState({
        entryEndA: JSON.parse(response.headers.pagination).totalItems,
      });
    } else {
      let value =
        parseInt(JSON.parse(response.headers.pagination).currentPage) *
        parseInt(this.assetPageSize);
      this.setState({ entryEndA: value });
    }
    if (
      this.state.entryEndA >
      parseInt(JSON.parse(response.headers.pagination).totalItems)
    ) {
      this.setState({
        entryEndA: JSON.parse(response.headers.pagination).totalItems,
      });
    }
    if (this.state.assetsList == "") {
      this.setState({ entryStartA: "0", entryEndA: "0", totalEntryA: "0" });
    }
  };
  postAssets = async (url) => {
    this.props.setLoadingPageAction(true);

    try {
      const assetsList = await axios.post(
        url,
        {},
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );
      console.log("asssetttttt",assetsList);
      this.setState({
        assetsList: assetsList.data,
        assetsPageCount: JSON.parse(assetsList.headers.pagination).totalPages,
      });
      console.log("assetsList ", assetsList.data);
      var radio = document.getElementsByClassName("inputRadio");
      for (var i in radio) {
        if (radio[i].value == this.state.assetId) {
          radio[i].checked = true;
        }
      }
      this.handleShowAssetsResults(assetsList);

      this.props.setLoadingPageAction(false);
    } catch (e) {
      if (e.response && e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`);
      }
      this.props.setLoadingPageAction(false);

      console.log(`😱 Axios request failed: ${e}`);
    }
  };

  handleCustomeridChange(e) {
    // console.log("e.target.value", e.target.value);
    if (e.target.value == "default") {
      this.setState({
        entryStartA: "0",
        entryEndA: "0",
        totalEntryA: "0",
        totalEntryFilterA: "0",
      });
    }
    if (e.target.value == "default") {
      this.setState({
        customerID_error: true,
        assetId: "",
        assetName: "",
      });
    } else {
      this.setState({ customerID_error: false, assetId: "", assetName: "", });

    }
    this.setState({ customerID: e.target.value });
    if (e.target.value !== "default") {
      this.unCheckradio();
      // console.log("customeridd",this.state.customerID)
      this.customerid = e.target.value;
      let query = encodeQueryData(this.setAssetQueryObject());
      let urlAssets = `${apiHost}/api/Device/AssetsByCustomerIdForDevice/${this.customerid}?${query}`;
      // console.log("resultttt",urlAssets);
      this.postAssets(urlAssets);
    }
  }

  handleNameChange(e) {
    console.log("e.target.value", e.target.value);
    if (e.target.value == "") {
      this.setState({ name_error: true });
    } else {
      this.setState({ name_error: false });
    }
    this.setState({ name: e.target.value });
  }
  handleImeiChange = (e) => {
    console.log("imei value", e.target.value);
    if (e.target.value == "") {
      this.setState({ imei_error: true });
    } else {
      this.setState({ imei_error: false });
    }
    this.setState({ imei: e.target.value });
  };

  handleSimChange = (e) => {
    console.log("sim change", e.target.value);
    this.setState({ sim: e.target.value });
  };

  handleTypeChange = (e) => {
    console.log("Type change", e.target.value);
    this.setState({ type: e.target.value });
  };

  handleTagChange = (e) => {
    console.log("Type change", e.target.value);
    this.setState({ tag: e.target.value });
  };

  handleNetworkTypeChange = (e) => {
    console.log("Network change", e.target.value);
    this.setState({ networkType: e.target.value });
  };

  handleFirmwareChange = (e) => {
    console.log("Firmware change", e.target.value);
    this.setState({ firmware: e.target.value });
  };
  handleAssetSelction = (e, name) => {
    console.log(e.target);
    console.log(name);
    this.setState({
      assetId: e.target.value,
      assetName: name,
    });
  };
  handleDescriptionChange(e) {
    this.setState({ description: e.target.value });
  }

  handleStatusChange(e) {
    this.setState({ status: e.target.value });
    console.log(e.target.value);
  }

  async handleSubmit() {
    this.formSubmit = true;
    if (this.state.customerID == "default") {
      this.setState({ customerID_error: true });
      this.formSubmit = false;
    }
    if (this.state.imei == "") {
      this.setState({ imei_error: true });
      this.formSubmit = false;
    }
    if (this.state.name == "") {
      this.setState({ name_error: true });
      this.formSubmit = false;
    }

    if (this.formSubmit) {
      this.props.setLoadingPageAction(true);

      // console.log("apiobj",this.state.icon,this.state.color,this.state.description,this.state.customerID,this.state.name,this.state.status);
      try {
        const response = await axios.post(
          `${apiHost}/api/Device/Update`,
          {
            Id: this.state.deviceDetails.id,
            Imei: this.state.imei,
            Name: this.state.name,
            Description: this.state.description,
            SimNumber: this.state.sim,
            Type: this.state.type,
            Tag: this.state.tag,
            NetworkType: this.state.networkType,
            FwVersion: this.state.firmware,
            CustomerId: this.state.customerID,
            AssetId: this.state.assetId || null,
            DeviceStatusName: this.state.status,
            swVersion: this.state.deviceDetails.software,
            hwVersion: this.state.deviceDetails.hwVersion,
            dbUpdated: this.state.deviceDetails.dbUpdated,
            dbCreated: this.state.deviceDetails.dbCreated,
          },
          {

            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }
        );
        console.log("customer id", response.data);
        this.props.setLoadingPageAction(false);
        // this.props.history.push("/devices");
        this.props.history.goBack();
      } catch (e) {
        if (e.response && e.response.status == "401") {
          this.props.history.push("/login");
        } else {
          this.props.setLoadingPageAction(false);
          if (e.response && e.response.data && e.response.data.statusCode == "8") {
            this.props.setErrorMessageAction("IMEI Already Exist");
          } else {
            this.props.setErrorMessageAction(`${e}`);
          }
        }
        console.log(`😱 Axios request failed: ${e}`);
      }
    }
  }
  render() {
    const arr = [10, 25, 50, 100];
    const selectedCustomer = this.state.customerList.find(
      (customer) => customer.id === this.state.customerID
    );
    const isLinkedToAsset = Boolean(this.state.assetId && this.state.assetName);
    const isDmcOnline =
      this.state.dmcStatus && this.state.dmcStatus.isOnline === true;
    const dmcStatusKnown =
      !this.state.dmcStatusLoading && this.state.dmcStatus !== null;

    return (
      <div>
        <Layout>
          <Helmet>
            <title>Edit Device </title>
          </Helmet>
          <div className="contentBody">
            <div className="contentWrapper device-edit-page">
              <div className="device-edit-header">
                <div>
                  <span className="device-edit-kicker">Device editor</span>
                  <h2>{this.state.name || "Edit Device"}</h2>
                  <div className="device-edit-subtitle">
                    <span>{this.state.imei || this.imei}</span>
                    {this.state.networkType && <span>{this.state.networkType}</span>}
                    {this.state.status && (
                      <span
                        className={
                          this.state.status === "Active"
                            ? "record-badge-active"
                            : this.state.status === "Disabled" || this.state.status === "Disable"
                              ? "record-badge-disabled"
                              : ""
                        }
                      >
                        {this.state.status === "Disable" ? "Disabled" : this.state.status}
                      </span>
                    )}
                    <span
                      className={
                        isLinkedToAsset
                          ? "device-edit-link-chip linked"
                          : "device-edit-link-chip unlinked"
                      }
                    >
                      {isLinkedToAsset ? "Linked to asset" : "No linked asset"}
                    </span>
                  </div>
                </div>
                <div className="device-edit-actions">
                  <Button
                    variant="outline-secondary"
                    onClick={() => {
                      this.props.history.goBack();
                    }}
                  >
                    Back to List
                  </Button>
                  <Button
                    variant="primary"
                    onClick={this.handleSubmit.bind(this)}
                  >
                    Save Changes
                  </Button>
                </div>
              </div>

              <Form className="device-edit-form device-edit-form-modern">
                <section className="device-edit-section">
                  <div className="device-edit-section-title">
                    <h3>Device Identity</h3>
                    <p>Core identifiers and naming used across AssetTrak.</p>
                  </div>
                  <div className="device-edit-grid">
                    <Form.Group controlId="deviceImei">
                      <Form.Label>IMEI</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.imei}
                      onChange={this.handleImeiChange.bind(this)}
                    />
                    <p
                      style={
                        this.state.imei_error
                          ? { color: "#a94442", fontSize: "14px" }
                          : { display: "none" }
                      }
                    >
                      The IMEI field is required.
                    </p>
                    </Form.Group>

                    <Form.Group controlId="deviceName">
                      <Form.Label>Name</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.name}
                      onChange={this.handleNameChange.bind(this)}
                    />
                    <p
                      style={
                        this.state.name_error
                          ? { color: "#a94442", fontSize: "14px" }
                          : { display: "none" }
                      }
                    >
                      The Name field is required.
                    </p>
                    </Form.Group>

                    <Form.Group className="device-edit-wide" controlId="deviceDescription">
                      <Form.Label>Description</Form.Label>
                    <Form.Control
                      as="textarea"
                      value={this.state.description}
                      onChange={this.handleDescriptionChange.bind(this)}
                      rows="3"
                    />
                    </Form.Group>
                  </div>
                </section>

                <section className="device-edit-section">
                  <div className="device-edit-section-title device-edit-section-title-action">
                    <div>
                      <h3>Hardware</h3>
                      <p>SIM, model, network, firmware and operational tags.</p>
                    </div>
                    <div className="device-dmc-actions">
                      <span
                        className={
                          isDmcOnline
                            ? "device-dmc-indicator online"
                            : "device-dmc-indicator offline"
                        }
                      >
                        <span></span>
                        {this.state.dmcStatusLoading
                          ? "Checking..."
                          : isDmcOnline
                          ? "Online"
                          : "Offline"}
                      </span>
                      <Button
                        variant="outline-primary"
                        className="device-web-dmc-button"
                        onClick={this.handleOpenWebDmc}
                        disabled={!dmcStatusKnown || !isDmcOnline}
                      >
                        WEB-DMC
                      </Button>
                    </div>
                  </div>
                  <div className="device-edit-grid">
                    <Form.Group controlId="deviceSim">
                      <Form.Label>SIM</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.sim}
                      onChange={this.handleSimChange.bind(this)}
                    />
                    </Form.Group>

                    <Form.Group controlId="deviceType">
                      <Form.Label>Type/Model</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.type}
                      onChange={this.handleTypeChange.bind(this)}
                    />
                    </Form.Group>

                    <Form.Group controlId="deviceTag">
                      <Form.Label>Tag</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.tag}
                      onChange={this.handleTagChange.bind(this)}
                    />
                    </Form.Group>

                    <Form.Group controlId="deviceNetwork">
                      <Form.Label>Network</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.networkType}
                      onChange={this.handleNetworkTypeChange.bind(this)}
                    />
                    </Form.Group>

                    <Form.Group controlId="deviceFirmware">
                      <Form.Label>Firmware</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.firmware}
                      disabled
                    />
                    </Form.Group>

                    <Form.Group controlId="deviceSoftware">
                      <Form.Label>Software</Form.Label>
                      <Form.Control
                        type="text"
                        value={this.state.deviceDetails.software || ""}
                        disabled
                      />
                    </Form.Group>
                  </div>
                </section>

                <section className="device-edit-section">
                  <div className="device-edit-section-title">
                    <h3>Assignment</h3>
                    <p>Customer ownership, linked asset and current device status.</p>
                  </div>
                  <div className="device-edit-grid">
                    <Form.Group className="device-edit-wide" controlId="deviceCustomer">
                      <Form.Label>Customer</Form.Label>
                    <Form.Control
                      as="select"
                      value={this.state.customerID}
                      onChange={this.handleCustomeridChange.bind(this)}
                    >
                      <option value="default">Select Customer</option>
                      {this.state.customerList.map((customer, index) => {
                        return (
                          <option value={customer.id}>{customer.name}</option>
                        );
                      })}
                    </Form.Control>
                    <p
                      style={
                        this.state.customerID_error
                          ? { color: "#a94442", fontSize: "14px" }
                          : { display: "none" }
                      }
                    >
                      The Customer field is required.
                    </p>
                    </Form.Group>

                    <Form.Group controlId="deviceStatus">
                      <Form.Label>Status</Form.Label>
                      <Form.Control
                        as="select"
                        value={this.state.status}
                        onChange={this.handleStatusChange.bind(this)}
                      >
                        {this.state.statusList.map((item, index) => {
                          return <option value={item.name}>{item.name}</option>;
                        })}
                      </Form.Control>
                    </Form.Group>

                    <div
                      className={
                        isLinkedToAsset
                          ? "device-current-asset-card linked"
                          : "device-current-asset-card unlinked"
                      }
                    >
                      <div>
                        <Form.Label>Current Asset</Form.Label>
                        <div className="device-current-asset-value">
                          {this.state.assetName == ""
                            ? "UNASSIGNED"
                            : this.state.assetName}
                        </div>
                      </div>
                      {this.state.assetId && (
                        <Button
                          variant="outline-secondary"
                          className="device-unassign-button"
                          onClick={this.handleAssetClear}
                        >
                          Clear Asset
                        </Button>
                      )}
                    </div>
                  </div>

                  <div className="device-asset-panel">
                    <div className="device-asset-panel-header">
                      <div>
                        <h4>Available assets</h4>
                        <p>{selectedCustomer ? selectedCustomer.name : "Select a customer to assign an asset."}</p>
                      </div>
                      <div className="device-asset-toolbar">
                      <ShowEntries
                        showEntriesCallback={this.handleAssetShowEntries}
                        data={arr}
                      />
                      <Search searchCallback={this.handleAssetSearch} />
                      </div>
                    </div>
                    <Table className="device-asset-table" responsive>
                      <thead>
                        <tr>
                          <th></th>
                          <th>Name</th>
                          <th>Tag1</th>
                          <th>Tag2</th>
                          <th>Status</th>
                          <th>Updated</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.assetsList == "" ||
                        this.state.customerID == "default" ? (
                          <tr>
                            <td style={{ textAlign: "center" }} colSpan="6">
                              Nothing to show
                            </td>{" "}
                          </tr>
                        ) : (
                          this.state.assetsList.map((item, index) => {
                            return (
                              <tr>
                                <td>
                                  <input
                                    value={item.id}
                                    id={item.value}
                                    className="inputRadio"
                                    onChange={(e) => {
                                      this.handleAssetSelction(e, item.name);
                                    }}
                                    name="assetselection"
                                    type="radio"
                                  />
                                </td>
                                <td>{item.name}</td>
                                <td>{item.tag1}</td>
                                <td>{item.tag2}</td>
                                <td>{item.status}</td>
                                <td>{utcToLocal(item.dbUpdated)}</td>
                              </tr>
                            );
                          })
                        )}
                      </tbody>
                    </Table>
                    <div className="paginationDetails">
                      <ShowingResults
                        currentEntryStart={this.state.entryStartA}
                        currentEntryEnd={this.state.entryEndA}
                        totalEntries={this.state.totalEntryA}
                        totalFilterEntries={this.state.totalEntryFilterA}
                        filterMessage={this.state.filterMessageA}
                      />
                      <Paginations
                        onPagination={this.handleAssetPagination}
                        pageCount={this.state.assetsPageCount}
                        pageRange={5}
                      ></Paginations>
                    </div>
                  </div>
                </section>

                <div className="device-edit-meta">
                  <div>
                    <span>Created</span>
                    <strong>{this.state.deviceDetails.dbCreated ? utcToLocal(this.state.deviceDetails.dbCreated) : "Not created"}</strong>
                  </div>
                  <div>
                    <span>Updated</span>
                    <strong>{this.state.deviceDetails.dbUpdated ? utcToLocal(this.state.deviceDetails.dbUpdated) : "Not updated"}</strong>
                  </div>
                </div>

                <div className="device-edit-footer">
                  <Button
                    variant="outline-secondary"
                    onClick={() => {
                      this.props.history.goBack();
                    }}
                  >
                    Back to List
                  </Button>
                  <Button
                    variant="primary"
                    onClick={this.handleSubmit.bind(this)}
                  >
                    Save Changes
                  </Button>
                </div>
              </Form>
            </div>
          </div>
        </Layout>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  loading: state.loading,
});
const mapDispatchToProps = {
  setLoadingPageAction: setLoadingPage,
  setErrorMessageAction: setErrorMessage,
};

export default connect(mapStateToProps, mapDispatchToProps)(EditDevice);
